var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeForthBox2Icon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1183_112578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.2509 29.3777L42.9905 44.8259C42.8057 45.1359 42.6835 45.6934 42.7139 46.054L42.9809 48.6398C43.0801 49.5729 43.8711 50.0519 44.7399 49.6974L47.1526 48.7176C47.4892 48.5783 47.9231 48.2134 48.1062 47.8956L57.3666 32.4474C58.2152 31.0363 58.4205 29.5954 56.3419 28.3469C54.2745 27.1122 53.0994 27.9666 52.2509 29.3777Z",
    stroke: "#202020",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7969 32.252C51.6045 34.327 53.3338 35.5463 55.5461 35.2881",
    stroke: "#202020",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3984 49.2951V13.0951C20.3984 12.2115 21.1148 11.4951 21.9984 11.4951H40.3984C41.2821 11.4951 41.9984 12.2115 41.9984 13.0951V35.5951",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1992 50.0947V36.6947C26.1992 35.8111 26.9156 35.0947 27.7992 35.0947H34.5992C35.4829 35.0947 36.1992 35.8111 36.1992 36.6947V50.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8008 48.9951C10.8008 48.4221 10.8008 34.7039 10.8008 26.5939C10.8008 25.7102 11.5171 24.9951 12.4008 24.9951H20.4008",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1992 6.09473V10.2947",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 50.4951H35.7",
    stroke: "#202020",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 18.0947L28.7992 18.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 24.0947L28.7992 24.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1992 30.0947L28.7992 30.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5977 18.0947L37.1977 18.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5977 24.0947L37.1977 24.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5977 30.0947L37.1977 30.0947",
    stroke: "#266AD8",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1183_112578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(0 0.0947266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeForthBox2Icon2);
export default __webpack_public_path__ + "static/media/home-forth-box2-icon2.6244bcfbfc2bd0fa31a9dda4935deec0.svg";
export { ForwardRef as ReactComponent };